import React, { ReactNode } from 'react'
import styled from 'styled-components'

interface CustomConfirmationModalProps {
  message: string
  onConfirm: () => void
  onCancel: () => void
  cancelName?: string
  confirmName?: string
  children?: ReactNode
  wide?: boolean
}

const CustomConfirmationModal: React.FC<CustomConfirmationModalProps> = ({
  message,
  onConfirm,
  onCancel,
  cancelName = 'Cancel',
  confirmName = 'Confirm',
  children,
  wide,
}) => {
  return (
    <Overlay>
      <Modal $wide={wide}>
        <Message>{message}</Message>
        {children && <ChildrenWrap>{children}</ChildrenWrap>}
        <Actions>
          <CancelBtn onClick={onCancel}>{cancelName}</CancelBtn>
          <ConfirmBtn onClick={onConfirm}>{confirmName}</ConfirmBtn>
        </Actions>
      </Modal>
    </Overlay>
  )
}

export default CustomConfirmationModal

// ─── Styles ──────────────────────────────────────────────────────────────────

const Overlay = styled.div`
  position: fixed;
  z-index: 400;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
`

const Modal = styled.div<{ $wide?: boolean }>`
  background: #161616;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  padding: 24px;
  width: ${({ $wide }) => ($wide ? '85vw' : '320px')};
  max-width: ${({ $wide }) => ($wide ? '1000px' : '320px')};
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.5);
`

const ChildrenWrap = styled.div`
  overflow: auto;
  max-height: 60vh;
  border-radius: 6px;
`

const Message = styled.p`
  font-size: 14px;
  color: #a0a0a0;
  text-align: center;
  margin: 0;
  line-height: 1.5;
`

const Actions = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
`

const CancelBtn = styled.button`
  height: 34px;
  padding: 0 16px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
  color: #777;
  font-size: 13px;
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s;

  &:hover { border-color: rgba(255, 255, 255, 0.15); color: #a0a0a0; }
`

const ConfirmBtn = styled.button`
  height: 34px;
  padding: 0 16px;
  background: rgba(255, 68, 68, 0.1);
  border: 1px solid rgba(255, 68, 68, 0.3);
  border-radius: 6px;
  color: #ff4444;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;

  &:hover {
    background: rgba(255, 68, 68, 0.18);
    border-color: rgba(255, 68, 68, 0.5);
  }
`
